export default "__VITE_ASSET__BmInjRrg__"